
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import DateTimeRangePicker from '@/views/shouyin/statement/reconciliationDetails/components/SearchPopup.vue'
import { periodTypeList, formatDate, formatDateTime } from './../../index'
import dayjs from 'dayjs'

@Component({
  components: { DateTimeRangePicker }
})
class StepBasicInfo extends Vue {
  @Prop({ default: () => ({}) }) formData!: any
  localForm = {
    lotteryName: '',
    lotteryTitle: '',
    periodType: '',
    statisticsStartTime: '',
    statisticsEndTime: '',
    lotteryStartTime: '',
    lotteryEndTime: '',
    isSelfEffect: 0 // (1自动生效0不自动生效)
  }

  calendarImgSrc = require('@/assets/images/marketActivity/calendar.png')

  // 弹窗数据
  showPeriodTypePicker = false
  showDatePicker = false

  // 当前选择的字段
  minDate = new Date(dayjs().subtract(10, 'year').format('YYYY-MM-DD'))
  maxDate = new Date(dayjs().add(10, 'year').format('YYYY-MM-DD'))
  curField = ''
  curDateTime = new Date()
  dateMinDate = this.minDate
  dateMaxDate = this.maxDate

  dateTimeRangeDefaultValue = null

  // 抽奖时间选择器限制
  startMinDate = this.minDate
  startMaxDate = this.maxDate
  startMinHour = 1
  startMaxHour = 23
  endMinDate = this.minDate
  endMaxDate = this.maxDate
  endMinHour = 1
  endMaxHour = 23

  get isEdit() {
    return !!this.$route.query.lotteryId
  }

  get isOnce() {
    return Number(this.localForm.periodType) === 1
  }

  get displaySQ() {
    return this.isOnce ? '' : '首期'
  }

  get periodTypeLabel() {
    const { periodType = 1 } = this.localForm
    const item = periodTypeList.find((p) => p.value === Number(periodType))
    return item.label || '--'
  }

  get periodTypeTips() {
    const addTimeText =
      Number(this.localForm.periodType) == 2 ? ' 7 天' : ' 1 月'
    return `活动为${this.periodTypeLabel}活动，后续每一期的的统计日期和抽奖时间将在本期基础上加${addTimeText}。`
  }

  get statisticsTimeErrMsg () {
    if (this.isOnce) {
      return '日期须在合法日期区间'
    } else {
      const text = Number(this.localForm.periodType) == 2 ? '一周' : '一个月'
      return `日期范围不可超过${text}`
    }
  }

  get lotteryTimeErrMsg () {
    if (this.isOnce) {
      return '日期须在合法日期区间'
    } else {
      const text = Number(this.localForm.periodType) == 2 ? '一周' : '一个月'
      return `抽奖时间距统计结束日期不可超过${text}`
    }
  }

  get periodTypeColumns() {
    return periodTypeList.filter((item) => item.value)
  }

  get displayStatisticsStart() {
    return formatDate(this.localForm.statisticsStartTime) || '开始日期'
  }

  get displayStatisticsEnd() {
    return formatDate(this.localForm.statisticsEndTime) || '结束日期'
  }

  get displayLotteryStart() {
    return formatDateTime(this.localForm.lotteryStartTime) || '请选择开始时间'
  }

  get displayLotteryEnd() {
    return formatDateTime(this.localForm.lotteryEndTime) || '请选择结束时间'
  }

  @Watch('localForm.periodType', { immediate: true })
  onPeriodTypeChange(newVal: number, oldVal: number) {
    // 修改配置时，无需监听
    if (this.isEdit) return
    // 初始化阶段（oldVal为空）且已有日期数据，说明是恢复父组件数据，不重置
    // 否则（用户切换周期类型或首次无数据）根据周期类型设置默认值
    if (!oldVal && this.localForm.statisticsStartTime && this.localForm.statisticsEndTime) {
      return
    }

    // 统计日期默认值
    const { statisticsStartTime, statisticsEndTime }: any = this.getStatisticsTimeDefaultVal()
    this.localForm.statisticsStartTime = statisticsStartTime
    this.localForm.statisticsEndTime = statisticsEndTime
    // 抽奖时间默认值
    const { lotteryStartTime, lotteryEndTime }: any = this.getLotteryTimeDefaultVal()
    this.localForm.lotteryStartTime = lotteryStartTime
    this.localForm.lotteryEndTime = lotteryEndTime
    this.onInputChange()
  }

  // 监听统计结束日期变化，更新抽奖时间
  @Watch('localForm.statisticsEndTime')
  onStatisticsEndTimeChange(newVal: string, oldVal: string) {
    // 修改配置时，无需监听
    if (this.isEdit) return
    if (!newVal || newVal === oldVal) return

    this.setLotteryTimeRange('start')
    const { lotteryStartTime, lotteryEndTime } = this.localForm
    const lotteryStartTimeValueOf = dayjs(lotteryStartTime).startOf('day').valueOf()
    if (lotteryStartTimeValueOf > dayjs(this.startMaxDate).startOf('day').valueOf() || lotteryStartTimeValueOf < dayjs(this.startMinDate).startOf('day').valueOf()) {
      const { lotteryStartTime }: any = this.getLotteryTimeDefaultVal()
      this.localForm.lotteryStartTime = lotteryStartTime
      this.onInputChange()
      this.$toast('已自动调整至最近合法日期区间')
    }
    this.setLotteryTimeRange('end')
    const lotteryEndTimeValueOf = dayjs(lotteryEndTime).startOf('day').valueOf()
    if (lotteryEndTimeValueOf > dayjs(this.endMaxDate).startOf('day').valueOf() || lotteryEndTimeValueOf < dayjs(this.endMinDate).startOf('day').valueOf()) {
      const { lotteryEndTime }: any = this.getLotteryTimeDefaultVal()
      this.localForm.lotteryEndTime = lotteryEndTime
      this.onInputChange()
      this.$toast('已自动调整至最近合法日期区间')
    }
  }

  @Watch('localForm.lotteryStartTime')
  @Watch('localForm.lotteryEndTime')
  onLotteryTimeChange(newVal: string, oldVal: string) {
    if (!newVal || newVal === oldVal) return
    this.handLotteryTime()
  }

  validatePeriodType() {
    if (!this.periodTypeLabel) {
      // this.$toast('请选择活动举办周期')
      return false
    }
  }

  validateStatisticsTime() {
    // 修改配置时，无需再校验统计日期
    if (this.isEdit) return
    const { statisticsStartTime, statisticsEndTime } = this.localForm
    if (!statisticsStartTime || !statisticsEndTime) {
      // this.$toast('请选择统计日期')
      return false
    }
    
  }

  validateStatisticsTimeIsRight() {
    // 修改配置时，无需再校验统计日期
    if (this.isEdit) return
    const { statisticsStartTime, statisticsEndTime } = this.localForm
    if (dayjs(statisticsStartTime).valueOf() > dayjs(statisticsEndTime).valueOf()) {
      // this.$toast('开始日期不能晚于结束日期')
      return false
    }
  }

  validateStatisticsTimeIsRight2 () {
    // 修改配置时，无需再校验统计日期
    if (this.isEdit) return
    this.setDatePickerRange('end')
    const statisticsEndTimeValueOf = dayjs(this.localForm.statisticsEndTime).startOf('day').valueOf()
    if (statisticsEndTimeValueOf > dayjs(this.dateMaxDate).startOf('day').valueOf() || statisticsEndTimeValueOf < dayjs(this.dateMinDate).startOf('day').valueOf()) {
      // this.$toast('日期须在合法日期区间')
      return false
    }
  }

  validateLotteryTime() {
    // 修改配置时，无需再校验抽奖时间
    if (this.isEdit) return
    const { lotteryStartTime, lotteryEndTime } = this.localForm
    if (!lotteryStartTime || !lotteryEndTime) {
      // this.$toast('请选择抽奖时间')
      return false
    }
  }

  validateLotteryTimeIsRight() {
    // 修改配置时，无需再校验抽奖时间
    if (this.isEdit) return
    if (dayjs(this.localForm.lotteryStartTime).valueOf() < Date.now()) {
      // this.$toast('抽奖时间不可早于当前时间点')
      return false
    }
  }

  validateLotteryTimeIsRight2() {
    // 修改配置时，无需再校验抽奖时间
    if (this.isEdit) return
    const { lotteryStartTime, statisticsEndTime } = this.localForm
    if (dayjs(lotteryStartTime).valueOf() < dayjs(statisticsEndTime).valueOf()) {
      // this.$toast('抽奖时间不可早于统计日期')
      return false
    }
  }

  validateLotteryTimeIsRight3() {
    // 修改配置时，无需再校验统计日期
    if (this.isEdit) return
    this.setLotteryTimeRange('end')
    const lotteryEndTimeValueOf = dayjs(this.localForm.lotteryEndTime).startOf('day').valueOf()
    if (lotteryEndTimeValueOf > dayjs(this.endMaxDate).startOf('day').valueOf() || lotteryEndTimeValueOf < dayjs(this.endMinDate).startOf('day').valueOf()) {
      // this.$toast('日期须在合法日期区间')
      return false
    }
  }

  created() {
    // 初始化本地数据
    const today = dayjs().format('YYYY/MM/DD')
    const { lotteryName, lotteryTitle } = this.formData
    this.localForm = {
      ...this.localForm,
      ...(this.formData || {}),
      lotteryName: lotteryName || `幸运大抽奖${today}`,
      lotteryTitle: lotteryTitle || `幸运大抽奖`
    }
    this.onInputChange()
  }

  getStatisticsTimeDefaultVal () {
    const { periodType } = this.localForm
    switch (Number(periodType)) {
      case 1: {
        // 只办一次：统计日期默认值为【当前日期-7天 至 当前日期】
        const statisticsStartTime = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
        const statisticsEndTime = dayjs().format('YYYY-MM-DD')
        return { statisticsStartTime, statisticsEndTime }
      }
      case 2: {
        // 每周重复：统计日期默认值为【当前日期 至 当前日期+6天】
        const statisticsStartTime = dayjs().format('YYYY-MM-DD')
        const statisticsEndTime = dayjs().add(6, 'day').format('YYYY-MM-DD')
        return { statisticsStartTime, statisticsEndTime }
      }
      case 3: {
        // 每月重复：统计日期默认值为【当前日期 至 当前日期+1月-1日】
        const statisticsStartTime = dayjs().format('YYYY-MM-DD')
        const statisticsEndTime = dayjs().add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD')
        return { statisticsStartTime, statisticsEndTime }
      }
    }
  }

  getLotteryTimeDefaultVal () {
    const { periodType, statisticsEndTime } = this.localForm
    switch (Number(periodType)) {
      case 1: {
        // 只办一次
        // 抽奖时间默认值：当前日期+1天 08:00:00 至 当前日期+7天 20:00:00
        const statEndDate = dayjs(statisticsEndTime).startOf('day') // 统计结束日期
        const today = dayjs().startOf('day') // 今天
        // 最小日期：统计结束日期和今天的较大者
        const minDate = today.isAfter(statEndDate) ? today : statEndDate
        const lotteryStartTime = `${minDate.add(1, 'day').format('YYYY-MM-DD')} 08:00:00`
        const lotteryEndTime = `${minDate.add(7, 'day').format('YYYY-MM-DD')} 20:00:00`
        return { lotteryStartTime, lotteryEndTime }
      }
      case 2: {
        // 每周重复
        // 抽奖时间默认值：统计结束日期+1天 08:00:00 至 统计结束日期+7天 20:00:00
        const lotteryStartTime = `${dayjs(statisticsEndTime).add(1, 'day').format('YYYY-MM-DD')} 08:00:00`
        const lotteryEndTime = `${dayjs(statisticsEndTime).add(7, 'day').format('YYYY-MM-DD')} 20:00:00`
        return { lotteryStartTime, lotteryEndTime }
      }
      case 3: {
        // 每月重复
        // 抽奖时间默认值：统计结束日期+1天 08:00:00 至 统计结束日期+1个月 20:00:00
        const lotteryStartTime = `${dayjs(statisticsEndTime).add(1, 'day').format('YYYY-MM-DD')} 08:00:00`
        const lotteryEndTime = `${dayjs(statisticsEndTime).add(1, 'month').format('YYYY-MM-DD')} 20:00:00`
        return { lotteryStartTime, lotteryEndTime }
      }
    }
  }

  // 处理抽奖时间回显
  handLotteryTime() {
    const { lotteryStartTime, lotteryEndTime } = this.formData
    const startParsed = this.parseTime(lotteryStartTime)
    const endParsed = this.parseTime(lotteryEndTime)

    if (!startParsed || !endParsed) return

    const [startVal1, startVal2] = startParsed
    const [endVal1, endVal2] = endParsed

    this.dateTimeRangeDefaultValue = {
      value: 1,
      startVal1,
      startVal2,
      startDatetimeValueType: 0,
      showStartDatetimePicker: false,
      endVal1,
      endVal2,
      endDatetimeValueType: 0,
      showEndDatetimePicker: false,
      starttime: lotteryStartTime,
      endtime: lotteryEndTime
    }
  }

  // 解析时间字符串为 [dateArray, timeArray]
  parseTime(timeStr: string): [string[], string[]] | null {
    const match = timeStr?.match(
      /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/
    )
    if (!match) return null
    return [
      [match[1], match[2], match[3]],
      [match[4], match[5]]
    ]
  }

  openPeriodTypePicker(){
    // 修改配置时，不可编辑统计日期
    if (this.isEdit) {
      this.$toast('不可编辑')
      return
    }
    this.showPeriodTypePicker = true
  }

  // 打开日期选择
  openDatePicker(field: string) {
    // 修改配置时，不可编辑统计日期
    if (this.isEdit) {
      this.$toast('不可编辑')
      return
    }
    
    // 设置日期选择范围限制
    this.setDatePickerRange(field)

    setTimeout(() => {
      this.curField = field
      const dateStr =
        field === 'start'
          ? this.localForm.statisticsStartTime
          : this.localForm.statisticsEndTime
      if (dateStr) {
        this.curDateTime = new Date(formatDate(dateStr))
      } else {
        this.curDateTime = new Date()
      }

      this.showDatePicker = true
    })
  }

  // 设置日期选择器的范围限制
  setDatePickerRange(field: string) {
    const { periodType, statisticsStartTime } = this.localForm

    // 选择结束日期时，根据周期类型设置限制
    if (field === 'end' && statisticsStartTime) {
      const startDate = dayjs(statisticsStartTime)

      // 最小日期为开始日期（结束日期不能早于开始日期）
      this.dateMinDate = new Date(startDate.valueOf())

      switch (Number(periodType)) {
        case 2: // 每周重复：最多6天
        this.dateMaxDate = new Date(startDate.add(6, 'day').valueOf())
          break
        case 3: // 每月重复：最多1个月-1天
          this.dateMaxDate = new Date(startDate.add(1, 'month').subtract(1, 'day').valueOf())
          break
        default: // 只办一次：无限制
          this.dateMinDate = this.minDate
          this.dateMaxDate = this.maxDate
          break
      }
    } else {
      // 选择开始日期或其他情况，使用默认范围
      this.dateMinDate = this.minDate
      this.dateMaxDate = this.maxDate
    }
  }

  // 打开时间选择
  openDateTimeRangePicker(field: string) {
    // 修改配置时，不可编辑抽奖时间
    if (this.isEdit) {
      this.$toast('不可编辑')
      return
    }
    // 根据周期类型设置抽奖时间限制
    this.setLotteryTimeRange(field)
    setTimeout(() => {
      this.curField = field
      const isStart = field === 'start'
      this.dateTimeRangeDefaultValue = {
        ...this.dateTimeRangeDefaultValue,
        value: isStart ? 1 : 2,
        startDatetimeValueType: isStart ? 1 : 0,
        showStartDatetimePicker: isStart,
        endDatetimeValueType: isStart ? 0 : 1,
        showEndDatetimePicker: !isStart
      }

      ;(this.$refs.dateTimeRangePickerRef as any).showPopup()
    })
  }

  // 设置抽奖时间选择器的范围限制
  setLotteryTimeRange(field: string) {
    const { periodType, statisticsEndTime, lotteryStartTime } = this.localForm
    const isStart = field === 'start'

    // 获取统计结束日期
    const statEndDate = statisticsEndTime ? dayjs(statisticsEndTime) : dayjs()
    // 获取今天
    const today = dayjs().startOf('day')

    switch (Number(periodType)) {
      case 1: // 只办一次
        // 开始时间限制：①统计日期之后 ②当前日期及以后
        if (isStart) {
          // 最小日期：统计结束日期和今天的较大者
          const minDate = today.isAfter(statEndDate) ? today : statEndDate.add(1, 'day')
          this.startMinDate = new Date(minDate.valueOf())
          this.startMaxDate = this.maxDate
        } else {
          // 结束时间限制：不早于开始时间
          if (lotteryStartTime) {
            const startDate = dayjs(lotteryStartTime)
            this.endMinDate = new Date(startDate.valueOf())
          } else {
            const minDate = today.isAfter(statEndDate) ? today : statEndDate.add(1, 'day')
            this.endMinDate = new Date(minDate.valueOf())
          }
          this.endMaxDate = this.maxDate
        }
        break

      case 2: // 每周重复
        if (isStart) {
          // 开始日期：统计结束日期+1天 至 统计结束日期+7天
          this.startMinDate = new Date(statEndDate.add(1, 'day').valueOf())
          this.startMaxDate = new Date(statEndDate.add(7, 'day').valueOf())
        } else {
          // 结束日期：开始日期 至 统计结束日期+7天
          const startDate = lotteryStartTime ? dayjs(lotteryStartTime) : statEndDate.add(1, 'day')
          this.endMinDate = new Date(startDate.valueOf())
          this.endMaxDate = new Date(statEndDate.add(7, 'day').valueOf())
        }
        break

      case 3: // 每月重复
        if (isStart) {
          // 开始日期：统计结束日期+1天 至 统计结束日期+1个月
          this.startMinDate = new Date(statEndDate.add(1, 'day').valueOf())
          this.startMaxDate = new Date(statEndDate.add(1, 'month').valueOf())
        } else {
          // 结束日期：开始日期 至 统计结束日期+1个月
          const startDate = lotteryStartTime ? dayjs(lotteryStartTime) : statEndDate.add(1, 'day')
          this.endMinDate = new Date(startDate.valueOf())
          this.endMaxDate = new Date(statEndDate.add(1, 'month').valueOf())
        }
        break

      default:
        // 默认无限制
        this.startMinDate = this.minDate
        this.startMaxDate = this.maxDate
        this.endMinDate = this.minDate
        this.endMaxDate = this.maxDate
    }
  }

  // 周期确认
  onPeriodTypeConfirm(value: any) {
    this.clearFormValidate(['statisticsTime', 'lotteryTime'])
    this.localForm.periodType = value.value
    this.showPeriodTypePicker = false
  }

  // 日期确认
  // 日期确认
  onDateConfirm(value: Date) {
    // 验证日期范围
    if (!this.validateDate(value)) {
      return // 验证失败，不设置日期
    }

    // 格式化日期
    const dateStr = dayjs(value).format('YYYY-MM-DD')

    // 设置对应字段
    if (this.curField === 'start') {
      this.localForm.statisticsStartTime = dateStr
    } else {
      this.localForm.statisticsEndTime = dateStr
    }

    // 关闭弹窗并通知父组件
    this.showDatePicker = false
    this.onInputChange()
  }

  // 验证日期
  validateDate(value: Date): boolean {
    const { statisticsStartTime, statisticsEndTime } = this.localForm

    if (this.curField === 'start') {
      return true
      // // 如果结束日期为空，允许设置
      // if (!statisticsEndTime) return true

      // const startTime = dayjs(value)
      // const endTime = dayjs(statisticsEndTime)

      // if (startTime.isAfter(endTime, 'day')) {
      //   this.$toast('开始日期不能晚于结束日期')
      //   return false
      // }
    } else {
      // 如果开始日期为空，允许设置
      if (!statisticsStartTime) return true

      const endTime = dayjs(value)
      const startTime = dayjs(statisticsStartTime)

      if (endTime.isBefore(startTime, 'day')) {
        this.$toast('结束日期不能早于开始日期')
        return false
      }
    }

    return true
  }

  // 时间确认
  onDateTimeRangePickerConfirm(res: any) {
    this.dateTimeRangeDefaultValue = res
    const { starttime, endtime } = res
    this.localForm.lotteryStartTime = `${starttime}:00`
    this.localForm.lotteryEndTime = `${endtime}:00`
    this.onInputChange()
  }

  onDateTimeRangePickerSelectTypeChange(value: number) {
    const field = value === 2 ? 'end' : 'start'
    // 根据周期类型设置抽奖时间限制
    this.setLotteryTimeRange(field)
  }

  // 输入变化
  onInputChange() {
    this.$emit('update:formData', { ...this.localForm })
  }

  clearFormValidate(prop: string | string[]) {
    this.$emit('clearFormValidate', prop)
  }
}
export default StepBasicInfo
